<template>
  <div class="choose-products-page">
    <div v-if="isAmend" class="choose-order-amend-title">
      修改订单中
    </div>
    <StoreMenu @initAdditional="initAdditional" @getProductGroup="getCombo" :vipVolumeKey="vipVolumeKey" :isVipVolume="isVipVolume" :isAddCart="isAddCart"
               @getProductCombination="getProductCombination"></StoreMenu>
    <div class="choose-products-page-right">
      <!--购物车-->
      <Cart @initAdditional="initAdditional" @getProductGroup="initProductCombo" @saveAdditional="saveAdditional" :isAddCart="isAddCart"
            @initProductGroup="initProductCombo" @saveCombo="saveCombo"  :deliveryFee="deliveryFee"></Cart>
      <!--优惠-->
      <Discounts :isDelivery="isDelivery" :deliveryFee="deliveryFee" :isAmend="isAmend" :isAddCart="isAddCart"></Discounts>
      <more-info
        @update="isUpdate"
        :vipVolumeKey="vipVolumeKey"
        :isVipVolume="isVipVolume"
        @updatePayType="updatePayType"
        :isDelivery="isDelivery"
        :deliveryFee="deliveryFee"
        :cokeKey="cokeKey"
        :isAmend="isAmend"
        :isColaCupConversionListeningSet="isColaCupConversionListeningSet"
        :isAddCart="isAddCart"
      ></more-info>
    </div>
    <!--特殊要求-->
    <Modal v-model="additional.visible" width="570px">
      <div slot="header">{{additional.title}}</div>
      <div class="additional" v-if="additional.visible">
        <div class="additional-list ">
          <div class="additional-item  " v-for="(item, key) in additional.list" :key="key">
            <div class="am-inline-block am-pos-relative">
              <Button :class="{active: item.active}" @click.native="checkProductCopies(additional,item)">
                <span>第{{key + 1}}份餐</span>
              </Button>
              <div class="additional-item-close am-icon-close" @click="removeProductCopies(additional, item, key)"
                   v-if="additional.list.length >1"></div>
            </div>
            <!--单一种类的特殊要求-->
            <template v-if="additional.single">
              <InputQuantity size="small" v-model="item.num" class="am-margin-left-sm" style="width: 80px" :min="0"
                             :disabled="item.disabled" :max="item.maxNum"
                             @on-change="updateAdditional"></InputQuantity>
            </template>
            <template v-else>
              <!--多种类特殊要求的选择-->
              <InputQuantity size="small" prepend append style="width: 50px" v-model="item.num"
                             class="am-margin-left-sm" :max="item.maxNum" @on-blur="calculateProductMax(additional)"
                             @on-change="updateAdditional"></InputQuantity>
            </template>
          </div>
          <div class=" additional-add " v-if="!additional.single">
            <div class="additional-add-plus am-icon-plus" @click="addProductCopies(additional)"></div>
          </div>
        </div>
        <template v-for="(item, index) in additional.list" v-if="item.active">
          <Additional :value="item" :key="index" @updateAdditional="updateAdditional" :category="additional.category">
          </Additional>
        </template>
        <div class="additional-total ">
          <!-- ps:20240201 需求修改套餐子餐品特殊要求价格显示不包含子餐品本身的加价，仅包含特殊要求加价 -->
          <template v-for="(item, key) in additional.list">
            <span :key="key" v-show="item.active">
              <span>本份搭配总价:</span>
              <span
                class="prefix-price-unit am-color-price am-padding-horizontal-xs"
                v-if='!combo.visible'>{{currency}}{{item.totalCurrentProductPrice}}</span>
                
              <span
                class="prefix-price-unit am-color-price am-padding-horizontal-xs"
                v-else>{{(item.totalCurrentProductPrice-((item.price||0)*(item.num||0)))|computePrice}}</span>
              <span class="am-color-price">
                <span>(</span>
                <span class="prefix-price-unit" v-if='!combo.visible'>{{currency}}{{item.pricing|computePrice }}</span>
                <span class="prefix-price-unit" v-else>{{currency}}{{(item.pricing-(item.price||0))|computePrice }}</span>
                
                <span>X{{item.num}}份)</span>
              </span>
            </span>
          </template>
          <span class="am-padding-left-sm">
            <span>全部餐品总价:</span>
            <span class="prefix-price-unit am-color-price am-padding-left-xs" v-if='!combo.visible'>{{currency}}{{additional.totalProductPrice}}</span>
            <span class="prefix-price-unit am-color-price am-padding-left-xs" v-else>{{currency}}{{(additional.totalProductPrice-((additional.productPrice||0)*(additional.total||0)))|formatPrice}}</span>
          </span>
        </div>
      </div>
      <div slot="footer" class="am-text-center">
        <div class="am-inline-block">
          <template v-if="additional.single">
            <Button @click.native="saveOtherAdditional" class="am-btn-custom-default ">确定</Button>
          </template>
          <template v-else>
            <Button @click.native="saveAdditional()" class="am-btn-custom-default ">确定</Button>
          </template>
        </div>
        <Button @click.native="additional.visible = false" class="am-btn-custom-cancel am-margin-left-20">取消</Button>
      </div>
    </Modal>
    <!--套餐-->
    <Modal v-model="combo.visible" width="850px">
      <div slot="header">{{combo.title}}</div>
      <div class="combo ">
        <div class="combo-list ">
          <div class="am-margin-right-sm am-margin-bottom-sm combo-item  " v-for="(item, key) in combo.list"
               :key="key">
            <div class="am-inline-block">
              <Button :class="{active: item.active}" @click.native="checkProductCopies(combo,item)">
                <span>第{{key + 1}}份餐</span>
              </Button>
              <div class="combo-item-close am-icon-close" @click="removeProductCopies(combo, item, key)"
                   v-if="combo.list.length>1"></div>
            </div>
            <InputQuantity size="small" prepend append style="width: 50px" v-model="item.num" class="am-margin-left-sm"
                           @on-change="updateCombo" :max="item.maxNum"
                           @on-blur="calculateProductMax(combo)"></InputQuantity>
          </div>
          <div class="combo-add">
            <div class="additional-add-plus am-icon-plus" @click="addProductCopies(combo)"></div>
          </div>
        </div>
        <div class="combo-pane am-scroll" v-show="item.active" v-for="(item, key) in combo.list" :key="key">
          <!-- 主食start-->
          <div class="combo-main" v-for="(main, key) in item.mainList" :key="key">
            <div class="combo-title am-text-center  ">{{main.title}}</div>
            <div class="combo-content">
              <div class="combo-table " v-if="!main.hide">
                <div class="combo-tr">
                  <div class="combo-td combo-tr-title">
                    {{main.title}}
                  </div>
                  <div class="combo-td">
                    <RadioGroup v-model="main.checkValue" @on-change="updateCombo(item)">
                      <Radio :label="key" :key="key" v-for="(product, key) in main.cells" custom
                             :disabled="product.disabled" class="am-margin-top-10 am-margin-right-20">
                        <div slot-scope="{ currentValue }" class="am-button-custom "
                             :class="{active: currentValue, disabled: product.disabled}">
                          <div class="am-inline-block">
                            <span>{{product.name}} </span>
                            <span class=" am-padding-left-sm" v-if="product.hasStock">(库存：{{product.stockNum}})</span>
                            <span class="product.warnText">{{product.warnText}}</span>
                          </div>
                          <template v-if="product.property&&currentValue">
                            <div class="am-inline-block  combo-additional-button"
                                 @click.prevent="initComboAdditional(product)">
                              <span>特殊要求</span>
                              <span v-if="product.num" class="prefix-price-unit">
                                {{currency}}{{product.totalProductPrice}}
                                </span>
                            </div>
                          </template>
                        </div>
                      </Radio>
                    </RadioGroup>
                  </div>
                </div>
              </div>
              <template v-if="main.mainGroups">
                <ComboGroup :list="main.mainGroups" :combo="item"
                            @updateCombo="updateCombo" @initComboAdditional="initComboAdditional"></ComboGroup>
              </template>
            </div>
          </div>
          <!--主食end-->
          <!--副食区域start-->
          <template v-if="item.auxiliaryItem">
            <!-- <div class="combo-title am-text-center  ">{{item.auxiliaryItem.title}}</div> -->
            <div class="combo-title am-text-center">副食区</div>
            <div class="combo-content">
              <ComboGroup :list="item.auxiliaryItem.items" :combo="item" @updateCombo="updateCombo"
                          @initComboAdditional="initComboAdditional"></ComboGroup>
            </div>
          </template>
          <!--副食区域end-->
        </div>
        <div class="combo-total ">
          <template v-for="(item, key) in combo.list">
            <span :key="key" v-show="item.active">
              <span>本份搭配总价:</span>
              <span
                class="prefix-price-unit am-color-price am-padding-horizontal-xs">{{currency}}{{item.totalCurrentProductPrice}}</span>
              <span class="am-color-price">
                <span>(</span>
                <span class="prefix-price-unit">{{currency}}{{item.pricing }}</span>
                <span>X{{item.num}}份)</span>
              </span>
            </span>
          </template>
          <span class="am-padding-left-sm">
            <span>全部餐品总价:</span>
            <span class="prefix-price-unit am-color-price am-padding-left-xs">{{currency}}{{combo.totalProductPrice}}</span>
          </span>
        </div>
      </div>
      <div slot="footer" class="am-text-center">
        <div class="am-inline-block">
          <Button @click.native="saveCombo()" class="am-btn-custom-default">确定</Button>
        </div>
        <Button @click.native="combo.visible = false" class="am-btn-custom-cancel am-margin-left-20">取消</Button>
      </div>
    </Modal>
    <!--组合-->
    <Modal v-model="combination.visible" width="550px">
      <div slot="header">{{combination.title}}</div>
      <div class="combination" v-if="combination.visible">
        <div class="combination-wrap">
          <!--组合选项列表-->
          <div class="combination-item" v-for="(project, index) in combination.list" :key="index">
            <div class="combination-title">{{project.name}}</div>
            <RadioGroup v-model="project.checkValue"
                        @on-change="combinationProjectChange" class="am-padding-horizontal-xs">
              <Radio custom :label="item.uid" v-for="item in project.items" :key="item.uid"
                     class="am-margin-top-sm am-margin-right-20">
                <div slot-scope="{ currentValue }" class="am-button-custom " :class="{active: currentValue}">
                  {{item.name}}
                </div>
              </Radio>
            </RadioGroup>
          </div>
          <template v-if="combination.product&&combination.product.uid">
            <div class="combination-total ">
              <span>本地搭配总价:</span>
              <span class="prefix-price-unit am-color-price am-padding-horizontal-xs">{{currency}}{{(combination.price * combination.product.num).toFixed(2)}}</span>
              <span>
                <span>(</span>
                <span class="prefix-price-unit">{{combination.price}}</span>
                <span>X{{combination.product.num}}份)</span>
              </span>
              <span class="am-padding-left-sm">
              <span>全部餐品总价:</span>
                <span class="prefix-price-unit am-color-price am-padding-left-xs">{{currency}}{{(combination.price * combination.product.num).toFixed(2)}}</span>
              </span>
            </div>
          </template>
        </div>
      </div>
      <div slot="footer" class="am-text-center">
        <div class="am-cf">
          <!--组合购物车-->
          <div class="combination-cart  am-fl" v-if="combination.product">
            <div class="am-fl">
              <div class="combination-cart-product-name">
                <div class="am-button-custom " :class="{disabled: combination.product.warnText}">
                  <div class="am-inline-block am-pos-relative">
                    <span class="am-padding-right-sm">{{combination.product.name}}</span>
                    <span class="am-padding-right-sm am-color-price"
                          v-show="combination.product.warnText">{{combination.product.warnText}}</span>
                  </div>
                  <template v-if="combination.product.property">
                    <div class="am-inline-block  combination-additional-button"
                         @click="initCombinationAdditional(combination.product)">
                      <span>特殊要求</span>
                    </div>
                  </template>
                </div>
              </div>
            </div>
            <div class="am-padding-left-sm am-fl">
              <InputQuantity style="width: 90px" v-model="combination.product.num" :min="1"
                             :max="combination.maxNum"
                             :disabled="combination.product.disabled"></InputQuantity>
            </div>
          </div>
          <div v-else class="am-text-left am-color-price">
            餐品不存在,请重新选择组合
          </div>
          <div class="am-fr">
            <div class="am-inline-block">
              <Button @click.native="saveCombination" :disabled="combination.product.disabled"
                      v-if="combination.product" class="am-btn-custom-default">确定
              </Button>
            </div>
            <Button @click.native="combination.visible = false" class="am-btn-custom-cancel am-margin-left-20">取消
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import {
    calculateProductMax,
    calculateAdditional,
    calculateCombo,
    calculateAllAdditional,
    createCombo,
    createAdditional,
    isDisabled,
    isType,
    isChange,
    calculateAdditionalStock,
    calculateAllCombo,
    calculateComAdditionalStock,
    checkChoiceListSelect,
    getAdditionalUseMaterial,
    getComboUseProductsAndMaterial,
    calculateStockObjMerge,
    getRefIdMap
  } from '@/utils/productAction'
  import StoreMenu from '@/components/pages/order/StoreMenu'
  import Cart from '@/components/pages/order/Cart'
  import Discounts from '@/components/pages/order/Discounts'
  import MoreInfo from '@/components/pages/order/MoreInfo'
  import Modal from '@/components/Modal'
  import Button from '@/components/Button'
  import InputQuantity from '@/components/InputQuantity/index'
  import Radio from '@/components/Radio/index'
  import RadioGroup from '@/components/RadioGroup/index'
  import CheckboxGroup from '@/components/CheckboxGroup/index'
  import Checkbox from '@/components/Checkbox/index'
  import ComboGroup from '@/components/business/ComboGroup/index'
  import Additional from '@/components/business/Additional'
  import {indexOf, deepClone, each, find, formatTime, formatPrice, getUrlParameter, format} from '@/utils/assist'
  import {toFixed} from '@/utils/overwriting'
  import Emitter from '@/components/emitter'
  import utils from '@os-plugins/util.js';

  const computePrice = (price)=> utils.computePrice(price,2);

  // 格式化预约时间的日期和时间分割
  function formatTypeDate(list) {
    let dateOption = [];
    each(list, (value, index) => {
      let times = value.times,
        list = [],
        i = 0;
      each(times, (value) => {
        let min = 0, max = 0, interval = 15;
        value.replace(/^(\d{2}):(\d{2})~(\d{2}):(\d{2})$/g, function (time, $1, $2, $3, $4) {
          min = parseInt($1) * 60 + parseInt($2);
          max = parseInt($3) * 60 + parseInt($4)
        });
        while (max >= min) {
          list.push({label: formatTime(min * 60 * 1000, 'hh:mm'), value: i});
          min += interval;
          i++
        }
      });
      dateOption.push({
        label: value.date,
        value: index,
        list
      })
      // timeOption.push(list)
    });
    return dateOption
  }
  function vipCouponCalculate (totalPrice) {
    let list = [
      {s: "1500", e: "2499.99", p: 100},
      {s: "2500", e: "3999.99", p: 200},
      {s: "4000", e: "5999.9", p: 400},
      {s: "6000", e: "7999.99", p: 600},
      {s: "8000", e: "9999.99", p: 800},
      {s: "10000", e: "11999.99", p: 1000},
      {s: "12000", e: "13999.99", p: 1200},
      {s: "14000", e: "15999.99", p: 1400},
      {s: "16000", e: "17999.99", p: 1600},
      {s: "18000", e: "19999.99", p: 1800},
      {s: "20000", e: "24999.99", p: 2000},
      {s: "25000", e: "29999.99", p: 2500},
      {s: "30000", e: "34999.99", p: 3000},
      {s: "35000", e: "39999.99", p: 3500},
      {s: "40000", e: "44999.99", p: 4000},
      {s: "45000", e: "49999.99", p: 4500},
      {s: "50000", e: Infinity, p: 5000},
    ], refundMoney = 0;
    if (totalPrice>= list[0].s) {
      list.some(obj=> {
        let min = obj.s, max = obj.e;
        if (min <= totalPrice&&totalPrice<=max) {
          refundMoney = obj.p;
          return true;
        }
      })
    }
    return refundMoney === 0 ? 0 : refundMoney/100
  }
  const combinationObj = {
      visible: false,
      title: '', // 标题
      product: {}, // 当前产品
      list: [], // 组合列表
      products: {}, // 产品列表
      item: {}, // 组合的项
      price: 0, // 单价
      maxNum: null,
    }, additionalOrComboObj = {
      visible: false,
      title: '',// 标题
      key: '',  // 餐品key
      list: [], // 份数表
      maxNum: null, // 最大库存数量
      param: null, // 默认复制副本
      totalProductPrice: 0, // 餐品总价
      total: 0, // 餐品总数量
      stockObj: {len: 0}, // 库存加料
      refIdObj: {len: 0} // 公共加料库存
    },
    productsObj = {}; // 餐品集合对象
  export default {
    name: 'orderCache',
    mixins: [Emitter],
    provide() {
      return {
        products: this.products,
        productsUseMaterialStock: this.productsUseMaterialStock,
        productsRefIdMap: this.productsRefIdMap,
        productsUseNum: this.productsUseNum
      }
    },
    created() {
      // 覆盖原生方法
      toFixed();
      let urlObj = getUrlParameter();
      if (urlObj.hasOwnProperty('vipVolumeUid')&&urlObj.vipVolumeUid) { // 默认挂载链接上
        this.vipVolumeUid = [Number(urlObj.vipVolumeUid)];
      }
      if (urlObj.hasOwnProperty('cokeId')&&urlObj.cokeId) {
        this.cokeIds = [Number(urlObj.cokeId)]
      }
      this.orderType = this.sendType * 1;
    },
    activated() {
      if (this.isAmend) { // 是否修改状态
        if (this.products.length === 0 && this.cart._products.length) { // 本地购物车没有以及vuex购物车存在餐品
          this.getProducts();
        }
        if (this.isFirst) { // 首次把门店 业务 配送费写进去
          this.initAppointmentTime();
          this.orderType = this.sendType;
          this.isFirst = false;
          this.oldStoreId = this.storeId;
          this.storeDelivery = this.store.fee;
          this.triggerUpdate( 'order-update', {
            isAmend: true
          });
        }
      } else {
        this.isFirst = true;
        this.isUpdate();
      }
    },
    mounted() {
    },
    watch: {
      'cart._products'(n, o) { // 购物车变化， 生成本地购物车
        //if (n === o) return;
        this.getProducts()
      },
      isAmend (val) {
        if (!val) {
          this.isUpdate('clear');
          this.isFirst = true
        }
      }
    },
    data() {
      return {
        currency: window.currency,
        isFirst: true, // 首次进入页面
        cokeIds: [26224532, 26224531], // 可乐餐品ID
        isPingAnBank: false, // 是否平安银行
        storeDelivery: 0, // 店铺配送费
        vipVolumeUid: [12414108, 12520723], // 贵宾卷ID
        oldStoreId: null, // 旧门店
        appointmentDate: null, // 预约时间
        orderType: null, // 订单类型
        productsRefIdMap: {}, // 公共物料映射 {uid: refID}
        productsUseMaterialStock: {}, // 特殊要求使用的加料 {uid: num}
        productsUseNum: {}, // 餐品使用数量 { pid: num}
        additional: { // 特殊要求对象
          single: false,
          ...deepClone(additionalOrComboObj)
        },
        combo: { // 套餐对象
          ...deepClone(additionalOrComboObj)
        },
        combination: {
          ...deepClone(combinationObj)
        },
        products: [], //购物车的餐品列表
        remarkList: {} // 备注列表
      }
    },
    computed: {
      ...mapState({
        oprInfo: state => state.booking.user.oprInfo, // 运营商数据
        storeId: state => state.booking.user.storeId, // 门店ID
        store: state => state.booking.store.data, // 门店信息
        user: state => state.booking.user.data, //用户信息
        order: state => state.booking.order, // 订单信息
        cart: state => state.booking.cart, // 购物车信息
        menu: state => state.booking.menu.data, // 餐单信息
        sendType: state => state.booking.user.sendType, // 业务类型
        reserveDate: state => state.booking.user.reserveDate, // 业务类型的提交的时间
        longitude: state => state.booking.user.longitude, // 经度
        latitude: state => state.booking.user.latitude, // 纬度
        isAmend: state => state.booking.user.orderAmend.isAmend,// 是否编辑
        isProductsAmend: state => state.booking.user.orderAmend.isProducts // 是否可以更改餐品
      }),
      isAddCart () { // 是否可以添加进购物车
        return !this.isAmend || !!(this.isAmend&&this.isProductsAmend)
      },
      isColaCupConversionListeningSet () { // 是否配置可乐杯转听
        return !!this.oprInfo.colaCupConversionListeningSet
      },
      vipVolumeCalculateType () { // 贵宾卷计算逻辑类型
        return !!this.oprInfo.vipVolumeCalculateType
      },
      isVipVolume() { // 是否配置了贵宾卷
        return !!this.oprInfo.vipVoucher
      },
      vipVolumeKey () { // 是否菜单有对应的贵宾卷
        let {isVipVolume, menu, vipVolumeUid } = this,
          {products} = menu,
          key = 0;
        if (isVipVolume&&Array.isArray(products)&&vipVolumeUid.length) {
          let vipUidObj = {}, product;
          each(vipVolumeUid, (value) => {
            vipUidObj[value] = true;
          });
          product = products.find(product => {
            let uid  = product.uid;
            if (vipUidObj[uid]) return product;
          });
          if (product) {
            key = product.uid;
          }
        }
        return key;
      },
      vipVolumeProduct () { // 贵宾卷代表的餐品
        let products = this.menu.products, vipVolumeKey = this.vipVolumeKey, product;
        if (Array.isArray(products)&&vipVolumeKey) {
          product = products.find(product => {
            let uid  = product.uid;
            if (uid === vipVolumeKey) return product;
          });
        }
        return product
      },
      cokeKey () { // 可乐对应的key
        let products = this.menu.products, key = 0, cokeIds = this.cokeIds;
        if (cokeIds.length&&this.isColaCupConversionListeningSet) {
          let cokeObj = {}, product;
          each(cokeIds, (value) => {
            cokeObj[value] = true;
          });
          if (Array.isArray(products)){
            product = products.find(product => {
              let uid = product.uid;
              if (cokeObj[uid]) return product;
            });
            if (product) key = product.uid;
          }
        }
        return key;
      },
      isDelivery () {    // 是否免配送费
        let orderType = this.sendType;
        return !(orderType === 2 || orderType === 3 ||  this.isPingAnBank)
      },
      deliveryFee () { // 配送费
        return this.products.length === 0 ? this.isDelivery ? this.store.fee : 0 : this.cart.fee.delivery;
      }
    },
    methods: {
      updatePayType (payTypes) {  // 支付类型更新操作 平安银行减免
        let [payType, payChildType] = payTypes,
          isPingAnBank = false,
          store = this.store,
          oldStoreDelivery = this.storeDelivery,
          storeDelivery = store.fee,
          update = oldStoreDelivery !== storeDelivery;
        if (this.oprInfo.choosePingAnBankAccept&&payType === 1 && payChildType === 12) { // 平安银行减免配送费
          update = true;
          storeDelivery = 0;
          isPingAnBank = true;
        } else {
          storeDelivery = oldStoreDelivery;
        }
        if (update) {
          this.$store.commit('booking/store/updateSingleData', { key: 'fee', value: storeDelivery});
          this.$store.commit('booking/store/updateSingleData', { key: 'deliveryFee', value: storeDelivery}); // 修改门店配送费 兼容
          this.$store.dispatch('booking/cart/updateCommon', {}); //更新购物车
        }
        this.isPingAnBank = isPingAnBank;
      },
      clearObjProperty(obj, source) {// 清除对象所有键值对  浅拷贝源属性
        if (typeof obj === 'object') {
          Object.keys(obj).forEach(el => {
            delete obj[el]
          });
          if (typeof obj === 'object') {
            Object.assign(obj, source)
          }
        }
      },
      getStore() {//获取门店详情
        let {storeId, longitude, latitude, isAmend} = this;
        return this.server.get({
          name: "getStoreInfoForCC",
          data: {
            storeId,
            coordinate: [longitude, latitude],
            checkChannel: !isAmend
          }
        }).then(res => {
          let data = res.data;
          this.initAppointmentTime(data);
          this.storeDelivery = data.fee;
          this.$store.dispatch('booking/store/init', {data: res.data})
        })
      },
      initAppointmentTime(store) { // 对预约自取时间的计算
        let {sendType} = this,
          {takeSelfTime, appointmentTime} = store || this.store,
          reserveDate = null,
          storeDateList = [],
          date = '',
          time = '';
        if (appointmentTime || takeSelfTime) {
          storeDateList = formatTypeDate(sendType === 2 ? takeSelfTime : appointmentTime);
          if (storeDateList.length) {
            date = storeDateList[0].label;
            time = storeDateList[0].list.length > 0 ? storeDateList[0].list[0].label : '';
          }
          reserveDate = (date + ' ' + time) || ''
        }
        reserveDate = reserveDate ? format(Date.parse(reserveDate)) : reserveDate;
        this.appointmentDate = reserveDate;
        this.$store.dispatch('booking/user/update', {
          storeDateList,
          reserveDate
        })
      },
      isUpdate(type) {
        // isStore判断门店更新 orderType业务类型更新 门店更新清除购物车
        let {storeId, orderType, sendType, reserveDate, appointmentDate, oldStoreId} = this,
          isStore = false,
          isOrderType = false,
          isAppointmentDate = false,
          isClear = false;
        // 触发更新的优先级 isStore > isOrderType ===  isAppointmentDate
          if (type === 'clear') {
            isClear = true;
            this.initAppointmentTime();
            this.triggerUpdate('order-update',{
              isClear
            });
            //清除购物车
            this.$store.dispatch('booking/cart/clear');
            this.orderType = sendType;
            this.clearObjProperty(productsObj);
            return
          }
        // console.log(appointmentDate, reserveDate);
        // 触发更新的优先级 isStore > isOrderType ===  isAppointmentDate
        if ((isStore = (oldStoreId !== storeId)) || (isOrderType = (orderType !== sendType)) || (isAppointmentDate = (!isOrderType && (appointmentDate !== reserveDate)))) {
          this.oldStoreId = storeId;
          this.appointmentDate = reserveDate;
          this.orderType = sendType;
          this.$store.dispatch('booking/order/update', {type: sendType});
          this.$store.dispatch('booking/cart/updateCommon'); //更新购物车
          this.comboGroups = [];
          if (isStore) {
            this.getStore().then(() => {
              this.triggerUpdate( 'order-update', {
                isStore
              })
            });
            this.clearObjProperty(productsObj);
          } else {
            // 业务更新
            if (isOrderType) {
              this.initAppointmentTime();
            }
            this.triggerUpdate( 'order-update', {
              isStore,
              isOrderType,
              isAppointmentDate
            })
          }
        }
      },
      triggerUpdate(name, o) {
        // 向子组件传播更新事件
        each(this.$children, (value) => {
          value.$emit(name, o)
        })
      },
      getProducts() {
        // 在vuex购物车的数据基础上，重新衍生新的购物车的显示 区分特殊要求和套餐两种类型
        let remarkList = {}, // 备注列表
          {cart, isVipVolume, vipVolumeKey, isAddCart } = this,
          products = {...cart.products}, // 购物车
          productsUseNum = {}, // 餐品使用数量
          productsUseMaterialStock = {}, // 餐品使用的加料统计
          fee = cart.fee,
          total = fee.products + fee.mealFee,
          productsRefIdMap = {},
          productVipVolume,
          list = [];
        each(this.products, (product) => {
          //  回收购物车的备注信息和备注状态
          let {_key, _index = 0, _remarkVisible = false, _remark = ''} = product,
            key = _key + _index;
          remarkList[key] = {_remarkVisible, _remark}
        });
        // 定制贵宾卷的
        if (isVipVolume && vipVolumeKey) { // 吉野家的贵宾卷
          let percentage = 0, vipVolumeNum = 0, vipVolumeCalculateType = this.vipVolumeCalculateType;
          if (vipVolumeCalculateType) { //  贵宾卷逻辑
            vipVolumeNum = vipCouponCalculate(total);
          } else {
            if (5000 <= total) {
              percentage = 0.1;
            } else if (3000 <= total) {
              percentage = 0.08;
            } else if (1500 <= total) {
              percentage = 0.05;
            }
            vipVolumeNum = parseInt(Math.floor((total * percentage) / 10) + '');
          }
          if (vipVolumeNum > 0) {
            let vipVolumeProduct = this.vipVolumeProduct,
                vipVolumeProducts = [];
            each(products, (product) => { // 改单的时候，判断购物车是否存在贵宾卷
              if (product.uid === vipVolumeKey) {
                vipVolumeProducts.push(product);
              }
            });
            if (vipVolumeProducts.length) { // 移除VUEX上购物车的贵宾卷
              return  each(vipVolumeProducts, product => {
                this.$store.dispatch('booking/cart/doMinus', {_key:product._key, num: 0});
              });
            }
            if (vipVolumeProduct) {
              products[vipVolumeKey] = {...vipVolumeProduct, num: vipVolumeNum, readonly: true, totalProductPrice: 0};
            }
          }
        }
        // 遍历购物车
        each(products, (product) => {
          let {_combo, type, _additional, isRequirement, _key, name, uid, num} = product,
            value = _combo || _additional,
            refIdObj = value&&( value.refIdObj || value.productRefIds);
          productsUseNum[uid] = (productsUseNum[uid] || 0) + num;
          if (vipVolumeKey === uid) return productVipVolume = product;
          if (type === 1 && !isRequirement) {
            // 单品
            let item = remarkList[_key] || {_remarkVisible: false, _remark: ''};
            list.push({...product, ...item, oldNum: product.num});
          }
          if (product.listRequirements) {
            // 特殊要求， 收集加料
            getAdditionalUseMaterial(product.listRequirements, productsUseMaterialStock);
          }
          if (refIdObj&&refIdObj.len) { // 收集公共加料
            Object.assign(productsRefIdMap, refIdObj)
          }
          //套餐
          getComboUseProductsAndMaterial(product.groups, productsUseNum, productsUseMaterialStock);
          if (value && value.list && value.list.length > 0) {
            each(value.list, (value, index) => {
              let key = _key + index,
                item = remarkList[key] || {_remarkVisible: false, _remark: ''};
              list.push({
                ...value,
                ...item,
                isChange: true,  // 是否可以修改 餐品名字 类型 是否支持特殊要求
                name,
                type,
                isRequirement,
                _key,
                uid: uid,
                oldNum: value.num,
                pid: uid
              })
            })
          }
        });
        if (productVipVolume) list.push(productVipVolume);
        if (!isAddCart) {
          each(list, product => {
            product.readonly = true
          })
        }
        this.clearObjProperty(this.productsUseNum, productsUseNum);
        this.clearObjProperty(this.productsUseMaterialStock, productsUseMaterialStock);
        this.clearObjProperty(this.productsRefIdMap, productsRefIdMap);
        this.products.splice(0, this.products.length, ...list);
        this.triggerUpdate('cart-update')
      },
      getProductCombination(product) { // 获取餐品组合
        let {storeId, menu} = this,
          _this = this,
          {uid, name} = product;
        this.server.get({
          name: "getProductCombination",
          data: {
            productId: uid,
            storeId,
            menuId: menu.menuId
          }
        }).then(res => {
          let data = res.data,
            products = {},
            list = data.types;
          each(list, value => {
            // 组合默认选中
            value.checkValue = value.items[0].uid
          });
          each(data.products, value => {
            // 对所有组合序列进行哈希存放
            let key = value.combinationTypeKey.replace(/\D*/g, '');
            products[key] = value.product
          });
          _this.combination = {..._this.combination, list, products};
          _this.combinationProjectChange(); // 默认触发选中
        });
        this.combination = {...combinationObj, visible: true, title: `餐品组合-${name}`, item: product}
      },
      combinationProjectChange() {
        // 组合项选中
        let {productsUseNum, combination, productsRefIdMap} = this,
          {activeBig, activeSmall} = this.$store.state.booking.menu,
          {list, products} = combination,
          maxNum = null,
          price = 0,
          product = {},
          disabled = false,
          keys = [activeBig, activeSmall],
          key = '';
        each(list, value => {
          // 获取选中的组合key
          if (value.checkValue) key += (value.uid + '' + value.checkValue)
        });
        if (products[key]) {
          // 存在对应餐品
          product = {...products[key], num: 1};
          keys.push(product.uid);
          product._key = keys.join('-'); // 修正组合的餐品
          isDisabled(product, 1);
          isType(product);
          isChange(product); // 餐品初始化
          price = product.price;
          if (product.disabled) {
            // 餐品是否禁用
            disabled = true;
          } else {
            let {uid} = product;
            maxNum = product.maxNum;
            if (maxNum !== null) { // 餐品有库存 减掉已经使用的餐品数量
              maxNum = maxNum - (productsUseNum[uid] || 0);
              product.maxNum = maxNum;
            }
            if (maxNum === 0) { // 餐品只能添加0数量, 直接售罄状态
              disabled = true;
              product.warnText = '已售罄'
            }
            if (product.isRequirement && !disabled) { // 餐品是否支持特殊要求
              let additional = createAdditional(product), // 创建特殊要求
                {stockObj, refIdObj} = additional, // 加料对象
                item = additional.list[0],
                productsUseMaterialStock = this.productsUseMaterialStock; // 已经使用的加料库存
              if (stockObj.len) {
                if (refIdObj.len) { // 存在公共加料 @getRefIdMap 映射公共加料UID @productsUseMaterialStock @calculateStockObjMerge 已使用加料数量
                  productsUseMaterialStock = getRefIdMap({...productsRefIdMap, ...refIdObj}, productsUseMaterialStock)
                }
                // stockObj 当前餐品拥有的加料数量
                stockObj = calculateStockObjMerge(stockObj, productsUseMaterialStock);
                // @calculateAdditionalStock 对加料进行计算
                calculateAdditionalStock(maxNum, [item], stockObj, 1);
                if (item.isSoldOut || item.stockNum == 0) { // 餐品加料售罄 或者 库存已满
                  disabled = true;
                  product.warnText = '已售罄'
                } else {
                  // maxNum 当前份能添加的最大库存数量
                  maxNum = Math.min(item.stockMax, maxNum);
                  price = calculateAdditional(item).totalCurrentProductPrice
                }
              } else {
                price = item ? item.pricing : 0;
              }
              product._additional = additional;
              additional.category = 'combination';
            }
          }
          if (disabled) {
            product.disabled = true;
            product.num = 0;
          }
        } else {
          product = null
        }
        combination.maxNum = maxNum;
        combination.price = formatPrice(price);
        combination.product = product
      },
      saveCombination() {
        // 保存组合的餐品
        let {combination, menu} = this,
          {product} = combination,
          key = product._key,
          menuProducts = menu.products,
          num = product.num * 1;
        if (num > 0) {
          let o = find(menuProducts, (value) => value.uid === product.uid); // 搜索该餐品是否在餐单
          if (o) key = o.value._key;
          else productsObj[key] = {...product}; // 不存在餐单的餐品
          // 是否有特殊要求
          if (product.isRequirement) {
            let additional = product._additional;
            additional.maxNum = product.hasStock ? product.stockNum : null; // 修正最大值不正确
            additional.single = false;
            additional.key = key;
            additional.visible = false;
            additional.list[0].num = num;
            this.additional = additional;
            this.saveAdditional();
          } else {
            this.$store.dispatch('booking/cart/doPlus', {...product, num});
          }
          this.combination.visible = false
        }
      },
      saveCombinationAdditional(additional) {
        // 保存组合的特殊要求
        let {combination} = this,
          product = combination.product,
          stockObj = additional.stockObj,
          item = additional.list[0],
          num = item.num,
          price = item.pricing;
        if (stockObj.len) {
          combination.maxNum = item.maxNum;
        }
        combination.product = {...product, num, _additional: additional};
        combination.price = price
      },
      initCombinationAdditional(product) {
        // 初始化组合里面的特殊要求
        if (product.disabled) return;
        let additional = product._additional,
          {list} = additional;
        if (list && list[0] && product.num) {
          let item = list[0];
          item.num = product.num; // 修正数量
          this.initAdditional({
            _key: product._key,
            notMenuProduct: product,
            single: true,
            buyMaxNum: additional.maxNum
          })
        }
      },
      saveCombo(...arg) {
        // 保存套餐
        let {combo, maxNum, productsRefIdMap} = this, product, key, isSubmit = true, errorDesc = '', count = 0;
        if (arg.length) {
          let item = arg[0], {_key, _index} = item, list = [];
          key = _key;
          product = this.findMenuProduct(_key);
          combo = {...product._combo};
          list.push(...combo.list);
          list.splice(_index, 1, item);
          combo.list = list;
        } else {
          key = combo.key;
          product = this.findMenuProduct(key)
        }
        let {productRefIds, productMaterialStock, productStockObj} = combo;
        // 存在D版块不满足的情况
        each(combo.list, (item, index) => {
          let {error,errorList} = checkChoiceListSelect(deepClone(item));
          let remainErrorList = deepClone((item.errorList || []).concat(errorList));

          if (item.error || error) {
            errorDesc += `第${index + 1}份餐品：`;
            isSubmit = false;
            each(remainErrorList, (value) => {
              errorDesc += `"${value.title}"中的区域不满足"${value.warnText}"条件`
            });
            errorDesc += ';'
          }
        });
        // 库存不足的情况
        if (maxNum) {
          each(list, (value) => {
            count += Number(value.num)
          });
          if (count > maxNum) {
            isSubmit = false;
            errorDesc = `库存不足,最多选择${maxNum}份餐品`;
          }
        }
        // 直接提交
        if (!isSubmit) {
          return this.$Modal.error({title: '提示', content: errorDesc})
        }
        calculateAllCombo(product, combo);
        if (productMaterialStock.len || productStockObj.len) {
          let {productUseNum, productUseMaterialStock} = getComboUseProductsAndMaterial(product.groups);
          if (productRefIds.len) {
            let productUseRefIdMaterialStock = getRefIdMap(productsRefIdMap, productUseMaterialStock);
            productUseMaterialStock = {...productUseMaterialStock, ...productUseRefIdMaterialStock}
          }
          product._combo.productUseNum = productUseNum;
          product._combo.productUseMaterialStock = productUseMaterialStock;
        }
        this.$store.dispatch('booking/cart/addGroups', {...product});
        combo.visible = combo.loading = false;
      },
      saveOtherAdditional() {
        // 其他特殊要求
        let {additional} = this;
                     
        // 检查多组多选必选是否已选
        for (const item of additional.list) {
          if(item.options) {
            for (const option of item.options) {
              option.value.selectNum = option.value.items.reduce((a,b)=>Number(a)+Number(b.num || 0), 0);
              if(option.value.isRequired && 
                  ((Object.prototype.toString.call(option.checkValue) == '[object Null]' && !option.value.isMultipleChoice) || 
                   (Object.prototype.toString.call(option.checkValue) == '[object Array]' && ((option.checkValue.length == 0 || ( option.checkValue && option.value.selectNum < option.value.minRequiredNum)) && option.value.isMultipleChoice)))
              ) {
                return Com.showToast(option.value.title + `请选择至少${option.value.minRequiredNum}份噢`);
              }
            }
          }
        }
        if (additional.category === 'combination') {
          // 组合特殊要求
          this.saveCombinationAdditional(additional)
        } else {
          // 套装特殊要求
          this.saveComboAdditional(this.combo.temporary, additional)
        }
        additional.visible = false;
        additional.product = null
      },
      saveComboAdditional(product, additional) {
        //保存套餐的特殊要求
        let {total} = additional;
        additional.single = true;
        product._additional = additional;
        product.num = total; // 修正餐品数量
        delete this.combo.temporary;
        this.updateCombo()
      },
      updateAdditional() {
        // 自动更新特殊要求计算 @productsUseMaterialStock 全局库存加料使用情况   @productsRefIdMap 全局公共加料映射 @comboSingleNum 套餐的当前数量
        let {additional, productsUseMaterialStock, productsRefIdMap} = this,
          {list, maxNum, comboSingleNum, stockObj, category, cartUseMaterialStock = {}, title, refIdObj} = additional,
          productSoldOutList = [], // 餐品售罄列表
          buyMaxNum = 0, // 最大可以购买数量
          isSoldOut = false, // 是否存在售罄
          isActive = false, // 是否存在选中
          replaceListData = [], // 暂存替换列表
          totalProductPrice = 0, // 总价格
          total = 0, // 数量
          neglect; // 是否忽略当前
        if (category === 'combo') {
          // 如果是套餐，忽略
          neglect = false;
        } else if (additional.key) {
          let key = additional.key;
          neglect = !this.cart.products[key]
        }
        if (stockObj.len) {
          // 是否存在库存
          if (category !== 'combo') { // 如果是套餐 直接忽略
            if (refIdObj.len) productsUseMaterialStock = {...productsUseMaterialStock, ...getRefIdMap({...productsRefIdMap, ...refIdObj}, productsUseMaterialStock)};
            stockObj = calculateStockObjMerge(stockObj, productsUseMaterialStock);
            stockObj = calculateStockObjMerge(stockObj, cartUseMaterialStock, '+');
          }
          calculateAdditionalStock(maxNum, list, stockObj, comboSingleNum || 1);
        }
        // 重新遍历当前份数
        each(list, (item) => {
          // 售罄
          if (item.isSoldOut) {
            // 抛进去售罄列表集合
            if (item.active) isActive = true;
            productSoldOutList.push(item);
            isSoldOut = true;
          }
          else {
            // 不售罄， 抛入替换列表
            replaceListData.push(item);
            buyMaxNum += item.num;
          }
        });
        if (isSoldOut) {
          // 存在售罄情况
          let errorStr = '';
          // 库存无限和实际数量小于库存数量
          if (maxNum === null || buyMaxNum <= maxNum) {
            errorStr = `${title}：`;
            each(productSoldOutList, (item) => {
              let errorList = item.errorList;
              if (errorList && errorList.length) {
                errorStr += errorList.join(',')
              }
            });
          } else {
            // 实际数量大于库存数量
            errorStr = `库存不足,最多选择${maxNum}份餐品`;
          }
          // 提示库存不存两种原因，本身餐品库存不足或者加料必选的库存不足
          this.$Modal.error({title: '提示', content: errorStr})
        }
        // 全部不满足 直接隐藏
        if (replaceListData.length === 0 && neglect) {
          return additional.visible = false;
        }
        // 修正每一份的对应maxNum
        calculateProductMax({list: replaceListData, maxNum});
        if (isActive && replaceListData.length) {
          // 修正选中的售罄
          replaceListData[replaceListData.length - 1].active = true
        }
        each(replaceListData, (item) => {
          Object.assign(item, calculateAdditional(item))
        });
        //  预计算总价格显示
        each(replaceListData, (item, index) => {
          let {pricing} = item,
            num = Number(item.num),
            totalCurrentProductPrice = computePrice(pricing * num);
            console.log('ddddddddddddddddddddddddddd:::::::::::', pricing, num, totalCurrentProductPrice);
          item._index = index; // 修正index
          item.num = num; // 修正数量
          item.totalCurrentProductPrice = totalCurrentProductPrice; // 修正单份总价
          totalProductPrice += totalCurrentProductPrice;
          totalProductPrice = computePrice(totalProductPrice);
          total += num;
        });
        totalProductPrice = computePrice(totalProductPrice);
        additional.list = replaceListData;
        additional.totalProductPrice = totalProductPrice;
        additional.total = total
      },
      updateCombo() {
        console.time();
        //更新套餐的数量和价格  @productsUseMaterialStock 全局使用加料库存数量 @productsRefIdMap 公共加料映射   @productsUseNum 餐品购物数量
        let {combo, productsUseMaterialStock, productsRefIdMap, productsUseNum} = this,
          // combo套餐对象包含 productUseNum 套餐里面餐品购物数量  productUseMaterialStock 加料库存使用数量   @productMaterialStock加料库存  @productStockObj餐品库存  @productRefIds 公共加料
          {list, maxNum, productUseNum = {}, productUseMaterialStock = {}, productMaterialStock, productStockObj, productRefIds, title, key} = combo,
          productSoldOutList = [], // 餐品售罄列表
          buyMaxNum = 0, // 最大可以购买数量
          isSoldOut = false, // 是否存在售罄
          isActive = false, // 是否存在选中
          replaceListData = [], // 暂存替换列表
          totalProductPrice = 0,
          neglect = !this.cart.products[key]; // 是否忽略当前
        if (productRefIds.len) {
          // 存在公共加料
          productsRefIdMap = Object.assign({}, productsRefIdMap, productRefIds);
        }
        // 餐品库存
        if (productStockObj.len) {
          // 剩下当前的餐品库存
          productStockObj = calculateStockObjMerge(productStockObj, productsUseNum, '-');
          // 还原本身餐品用的库存
          productStockObj = calculateStockObjMerge(productStockObj, productUseNum, '+')
        }
        if (productMaterialStock.len) {
          // 合并公共加料
          productsUseMaterialStock = Object.assign({}, productsUseMaterialStock, getRefIdMap(productsRefIdMap, productsUseMaterialStock));
          productMaterialStock = calculateStockObjMerge(productMaterialStock, productsUseMaterialStock);
          productMaterialStock = calculateStockObjMerge(productMaterialStock, productUseMaterialStock, '+');
        }
        calculateComAdditionalStock(list, productMaterialStock, productStockObj);
        // 重新遍历当前份数
        each(list, (item) => {
          // 售罄
          if (item.isSoldOut) {
            // 抛进去售罄列表集合
            if (item.active) isActive = true;
            productSoldOutList.push(item);
            isSoldOut = true;
          }
          else {
            // 不售罄， 抛入替换列表
            replaceListData.push(item);
            buyMaxNum += item.num;
          }
        });
        if (isSoldOut) {
          // 存在售罄情况
          let errorStr = '';
          // 库存无限和实际数量小于库存数量
          if (maxNum === null || buyMaxNum <= maxNum) {
            errorStr = `${title}：`;
            each(productSoldOutList, (item) => {
              let errorList = item.errorList;
              if (errorList && errorList.length) {
                errorStr += errorList.join(',')
              }
            });
          } else {
            // 实际数量大于库存数量
            errorStr = `库存不足,最多选择${maxNum}份餐品`;
          }
          // 提示库存不存两种原因，本身餐品库存不足或者加料必选的库存不足
          this.$Modal.error({title: '提示', content: errorStr})
        }
        // 全部不满足 直接隐藏
        if (replaceListData.length === 0 && neglect) {
          return combo.visible = false;
        }
        // 修正每一份的对应maxNum
        calculateProductMax({list: replaceListData, maxNum});
        if (isActive && replaceListData.length) {
          // 修正选中的售罄
          replaceListData[replaceListData.length - 1].active = true
        }
        each(replaceListData, (item) => {
          Object.assign(item, calculateCombo(item))
        });
        //重新计算套餐的价格
        each(replaceListData, (item) => {
          let {pricing, num} = item,
            totalCurrentProductPrice = pricing * num || 0;
          totalCurrentProductPrice = formatPrice(totalCurrentProductPrice);
          item.totalCurrentProductPrice = totalCurrentProductPrice;
          totalProductPrice += totalCurrentProductPrice
        });
        totalProductPrice = formatPrice(totalProductPrice);
        combo.totalProductPrice = totalProductPrice;
        combo.list = replaceListData;
        console.timeEnd()
      },
      calculateCombo,
      findMenuProduct(key) {
        // 查找对应餐品, 并返回对应餐品
        let products = this.menu.products, value = {}, cartProductsObj = this.cart.products;
        // 餐单餐品
        products.forEach(product => {
          if (product._key === key) value = {...product}
        });
        // 购物车餐品
        if (cartProductsObj.hasOwnProperty(key)) {
          Object.assign(value, {
            ...cartProductsObj[key]
          })
        }
        if (!value._key && productsObj[key]) value = {...productsObj[key]}; // 餐单和购物车都不存在，就直接拿存储餐品对象
        return value
      },
      saveAdditional(...arg) {
        // @arg 购物车操作传对应的当前份
        let {additional, cart, productsRefIdMap} = this, product, key;
        if (arg.length) {
          // 找到当前的所有份数 去替换目标份数, 重新去计算生成
          let item = arg[0], {_key, _index} = item, list = [];
          key = _key;
          product = this.findMenuProduct(_key);
          additional = {...product._additional};
          list.push(...additional.list);
          list.splice(_index, 1, item);
          additional.list = list.map((item) => {
            return {...item}
          })
        } else {
          key = additional.key;
          product = this.findMenuProduct(key);
        }
        // @category 类别   @refIdObj 公共加料库存映射  @stockObj 加料库存
        let {list, maxNum, category, refIdObj, stockObj} = additional,
          isCart = false,
          count = 0;
        isCart = !!cart.products[key];
        // 检查多组多选必选是否已选
        for (const item of list) {
          if(item.options) {
            for (const option of item.options) {
              option.value.selectNum = option.value.items.reduce((a,b)=>Number(a)+Number(b.num || 0), 0);
              if(option.value.isRequired && 
                  ((Object.prototype.toString.call(option.checkValue) == '[object Null]' && !option.value.isMultipleChoice) || 
                   (Object.prototype.toString.call(option.checkValue) == '[object Array]' && ((option.checkValue.length == 0 || ( option.checkValue && option.value.selectNum < option.value.minRequiredNum)) && option.value.isMultipleChoice)))
              ) {
                console.log('多组多选不通过：：：：：', option.value.title);
                return Com.showToast(option.value.title + `请选择至少${option.value.minRequiredNum}份噢`);
              }
            }
          }
        }
        if (category === 'combination') {
          if (isCart) {
            // 组合存在购物车，进行整合重新全部计算
            list = [].concat(cart.products[key]._additional.list.map((item) => {
              return {...item}
            }), list);
            additional.list = list;
          }
          // 删除是组合的标记
          delete additional.category
        }
        calculateProductMax(additional);
        if (maxNum) {
          each(list, (value) => {
            count += Number(value.num)
          });
          if (count > maxNum) {
            return this.$Modal.error({title: '提示', content: `库存不足,最多选择${maxNum}份餐品`})
          }
        }
        additional.single = false; // 修正特殊要求可以多份
        calculateAllAdditional(product, additional);
        if (stockObj.len) {
          // 获取当前餐品的使用的加料库存
          let productUseMaterialStock = getAdditionalUseMaterial(product.listRequirements);
          if (refIdObj.len) {
            // 存在公共加料 导入到全局公共映射
            Object.assign(productsRefIdMap, refIdObj);
            // 计算公共加料用了多少库存与普通加料库存一起存 cartUseMaterialStock
            let productUseRefIdMaterialStock = getRefIdMap(productsRefIdMap, productUseMaterialStock);
            productUseMaterialStock = {...productUseMaterialStock, ...productUseRefIdMaterialStock};
          }
          product._additional.cartUseMaterialStock = productUseMaterialStock;
        }
        // 是否存在购物车 调用方法
        if (isCart) this.$store.dispatch('booking/cart/changProductItem', {
          oldObj: product,
          type: 'change',
          obj: product
        });
        else this.$store.dispatch('booking/cart/doPlus', product);
        additional.visible = false;
      },
      getCombo(product) {
        //获取套餐
        let {store, cart} = this,
          {uid,  _key} = product,
          {menuId } = this.menu,
          item = {...product},
          key = _key;
        if (product.productGroup) {
          productsObj[key] = product;
        }
        if (productsObj[key]) {
          let o = {_key: key};
          if (!cart.products[key]) o.notMenuProduct = productsObj[key];
          this.initProductCombo(o);
        } else {
          this.server.get({
            name: "getProductGroup",
            data: {
              menuId,
              pid: uid,
              storeId: store.storeId,
              isCheckSoldOut: true
            }
          }).then(res => {
            let data = res.data;
            if (data.isSoldOut) return this.$Modal.error({title: '提示', content: '该套餐已售罄'});
            item.productGroup = data;
            productsObj[key] = item;
            this.initProductCombo({notMenuProduct: item})
          })
        }
      },
      initAdditional(arg) {
        // 初始特殊要求
        this.initProduct(arg);
      },
      initComboAdditional(product) { // 初始化套餐里的特殊要求
        if (product.disabled || product.forbiddenAdd) return;
        let obj = {notMenuProduct: product};
        this.combo.temporary = product;
        obj.buyMaxNum = product.buyMaxNum;
        this.initProduct(obj);
      },
      initProductCombo(arg) {//初始化套餐
        this.initProduct(arg)
      },
      initProduct({_key, action, notMenuProduct, _index, buyMaxNum, single = false}) {
        console.time();
        // 初始化特殊要求和套餐 @_key 餐品key  @action操作类型  @notMenuProduct 餐品 @_index 第几份 @buyMaxNum 最大购买数量 @single 是否可以多份
        let {cart, productsUseNum} = this,
          cartProductsObj = cart.products,
          product = notMenuProduct || this.findMenuProduct(_key),
          {groupType} = product,
          type = product.type * 1,
          attr = type === 1 ? 'additional' : 'combo',
          value,
          index = _index || 0,
          maxNum = typeof buyMaxNum === 'number' ? buyMaxNum : product.hasStock ? product.stockNum : null; // 修正库存;
        if (type === 1) {
          value = product._additional ? deepClone(product._additional) : createAdditional(product);
        } else if (type === 2) {
          value = product._combo ? deepClone(product._combo) : createCombo(product);
        }
        if (type === 1 && product.hasStock && _key && _key.indexOf('-') && buyMaxNum !== 'number') {
          // 是否库存 是否存在key 不存在传过来的最大值 单品的时候
          let pid = _key.split('-').slice(-1)[0];
          // 是否存在购物车上
          if (pid && productsUseNum[pid]) {
            maxNum = product.stockNum - productsUseNum[pid] + value.total || 0
          }
        }
        Object.assign(value, {
          visible: true,
          type,
          maxNum,
          single
        });
        this[attr] = value;
        if (notMenuProduct) {
          value.category = groupType ? 'combo' : 'combination';
          if (groupType) value.single = true;
        }
        if (value.list.length) {
          // 修正选中状态
          let item = value.list[index];
          item.active = false;
          this.checkProductCopies(value, item);
        }
        if ((_key && cartProductsObj[_key] && (action !== 'change')) || value.list.length === 0) {
          // 操作不是修改 默认为餐品添加一份 或者购物车份数为0的时候
          this.addProductCopies(value)
        } else {
          if (type === 2) {
            this.updateCombo()
          } else {
            this.updateAdditional()
          }
        }
      },
      checkProductCopies(o, item) {
        // 选中餐品当前的份数
        let {list} = o;
        if (item.active) return;
        each(list, value => value.active = false);
        item.active = true;
      },
      addProductCopies(o) {
        // 添加一份餐品
        let {list, param, maxNum, type} = o, item, count = 0;
        each(list, (item) => {
          count += item.num;
        });
        if (maxNum) {
          if (count >= maxNum) {
            return this.$Modal.error({title: '提示', content: `库存不足,最多选择${maxNum}份餐品`});
          }
        }
        item = deepClone(param);
        item.active = false;
        list.push(item);
        this.checkProductCopies(o, item);
        if (type === 2) this.updateCombo();
        else this.updateAdditional()
      },
      removeProductCopies(o, item, index) {
        // 移除一份餐品
        let {list, type} = o,
          maxIndex = list.length - 1,
          i;
        if (item.active) {
          // 如果移除的是选中状态, 就往后退选中
          i = maxIndex === index ? index - 1 : maxIndex;
          list[i].active = true;
          item.active = false;
        }
        list.splice(index, 1);
        type === 2 ? this.updateCombo() : this.updateAdditional()
      },
      calculateProductMax
    },
    components: {
      StoreMenu,
      Cart,
      MoreInfo,
      Discounts,
      Modal,
      Button,
      Additional,
      InputQuantity,
      CheckboxGroup,
      Checkbox,
      RadioGroup,
      Radio,
      ComboGroup
    },
    filters: {
      formatPrice,
      computePrice,
    }
  }
</script>

<style lang="less">

  .choose-products-page {
    display: flex;
    padding: 10px 10px 0 10px;
    flex-wrap: wrap;
  }
  .choose-order-amend-title {
    margin-top: -10px;
    margin-left: -10px;
    height: 40px;
    font-size: 18px;
    color: #fff;
    background-color: #3bb5e4;
    text-indent: 20px;
    line-height: 40px;
    width: 100%;
  }
  .choose-products-page-right {
    flex: none;
    width: 685px;
    margin-left: 30px;
  }
</style>
<style lang="less">
  /*重复方法*/
  .am-btn-plus () {
    &-add {
      &-plus {
        cursor: pointer;
        width: 30px;
        height: 30px;
        border-radius: 4px;
        display: inline-block;
        vertical-align: middle;
        background-color: #3b5d8b;
        color: #fff;
      }
    }
  }

  .am-btn-reduce () {
    &-sub {
      &-reduce {
        cursor: pointer;
        width: 30px;
        height: 30px;
        border-radius: 4px;
        display: inline-block;
        vertical-align: middle;
        background-color: #3b5d8b;
        color: #fff;
      }
    }
  };

  .am-tab() {
    position: relative;
    display: flex;
    align-items: center;
    margin-right: 16px;
    margin-bottom: 16px;
    &-close {
      width: 20px;
      height: 20px;
      border-radius: 10px;
      /*cursor: pointer;*/
      position: absolute;
      right: -10px;
      top: -10px;
      color: #fff;
      transform: rotate(45deg);
      background: #3b5d8b;
      z-index: 2;
    }
    & .am-btn {
      background: #fff;
      color: #545d66;
    }
    & .am-btn.active {
      color: #fff;
      background: #3b5d8b;
    }
  }

  @additional: ~'additional';
  @combo: ~'combo';
  @combination: ~'combination';
  .@{additional} {
    .am-btn-plus();
    .am-btn-reduce();
    .@{additional}-list {
      display: flex;
      flex-wrap: wrap;
      align-items: baseline;
    }
    .@{additional}-item {
      .am-tab();
    }
    .@{additional}-total {
      font-size: 16px;
    }
  }

  // 套餐
  .@{combo} {
    .am-btn-plus();
    .am-btn-reduce();
    .@{combo}-list {
      display: flex;
      flex-wrap: wrap;
      align-items: baseline;
    }
    .@{combo}-item {
      position: relative;
      .am-tab();
    }
    .@{combo}-content {
      margin-top: 16px;
    }
    .@{combo}-table {
      display: table;
      width: 100%;
      border: 1px solid #dcdee2;
      font-size: 14px;
    }
    .@{combo}-table + .@{combo}-table {
      border-top: none;
    }
    .@{combo}-tr {
      vertical-align: top;
      display: table-row;
      .@{combo}-td:first-child {
        width: 200px;
      }
      .@{combo}-td:last-child {
        border-right: none;
      }
    }
    .@{combo}-tr:last-child .combo-td {
      border-bottom: none;
    }
    .@{combo}-pane {
      max-height: 500px;
    }
    .@{combo}-td {
      padding: 8px 16px;
      display: table-cell;
      border-bottom: 1px solid #dcdee2;
      border-right: 1px solid #dcdee2;
    }
    .@{combo}-title {
      padding: 10px 0;
      text-align: center;
      background: #d3d6d5;
      font-weight: 400;
      white-space: nowrap;
      font-size: 1.25em;
    }
    .@{combo}-tr-title {
      vertical-align: middle;
      font-weight: 400;
      background-color: #ebeef0;
      font-size: 16px;
      text-align: center;
    }
    .@{combo}-label {
      flex: 1;
    }
    .@{combo}-additional-label {
      cursor: pointer;
      color: #37b6e6;
    }
    .@{combo}-additional-button {
      padding: 0 12px;
      margin-left: 12px;
      margin-right: -21px;
      /*margin-right: -1rem;*/
      background-color: #37b6e6;
      border-radius: 0 15px 15px 0;
      color: #fff;
      &.not {
        border-radius: 0;
        margin-right: 0;
      }
    }
    .@{combo}-total {
      padding-top: 16px;
      font-size: 16px;
    }
  }

  // 组合的样式
  .@{combination} {
    .@{combination}-item {
      margin-bottom: 16px;
    }
    .@{combination}-title {
      font-size: 16px;
    }
    .@{combination}-total {
      font-size: 16px;
    }
  }

  .@{combination}-cart-product-name {
    font-size: 1.25em;
    font-weight: 500;
    line-height: 32px;
  }

  .@{combination}-cart-product-additional {
    color: #37b6e6;
  }

  .@{combination}-additional-button {
    padding: 0 12px;
    margin-right: -21px;
    background-color: #37b6e6;
    border-radius: 0 15px 15px 0;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// pagesCache/order/order.vue